<template>
    <div class="education-item-root p-2" :class="[enumKey]" @click="onEdit">
        <div class="d-flex align-items-center justify-content-center">
            <img v-if="logo" :src="logo" :alt="school" />
            <BaseIcon v-else name="graduation-cap" size="3x" />
        </div>

        <div>
            <h6 v-if="getSchool().name" class="subtitle mb-2">
                {{ getSchool().name }}
            </h6>
            <h6 class="title bold mb-1">{{ degree }}</h6>
            <h6 class="caption gray-color">{{ graduationText() }}</h6>
        </div>

        <IconBtn class="m-auto" name="pen" color="secondary" />
    </div>
</template>

<script>
import moment from 'moment';

// Utils
import StateEnum from '~/utils/StateEnum';

export default {
    name: 'EducationItem',
    props: {
        school: Object,
        degree: String,
        logo: String,
        graduationDate: String,
        state: Number,
    },
    computed: {
        enumKey() {
            return Object.keys(StateEnum)[this.state] || '';
        },
    },
    methods: {
        graduationText() {
            const graduationDate = moment(this.$props.graduationDate);
            if (
                !graduationDate.isValid() ||
                moment().diff(graduationDate) < 0
            ) {
                return this.$t('spotlight.education.notGraduated');
            }
            return this.$t('spotlight.education.graduatedIn', {
                date: graduationDate.format('MMM YYYY'),
            });
        },
        onEdit() {
            this.$emit('onEdit');
        },
        getSchool() {
            return this.school || {};
        },
    },
};
</script>

<style scoped>
.education-item-root {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 2px;

    display: grid;
    grid-template-columns: 80px auto 38px;
    grid-gap: 16px;
}

@media only screen and (max-width: 600px) {
    .education-item-root {
        grid-template-columns: auto;
        justify-content: center;
        text-align: center;
    }
}
</style>
